export const SET_GAMIFICATION = 'GAMIFICATION/SET_GAMIFICATION'
export const SET_GAMIFICATIONS = 'GAMIFICATION/SET_GAMIFICATIONS'
